module.exports = __webpack_public_path__ + "img/prize.1eb0e3d1.png";